// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Main-module--bx--text-truncate--end--wdLYS";
export var bxTextTruncateFront = "Main-module--bx--text-truncate--front--1M4gZ";
export var main = "Main-module--main--2_t07";
export var padded = "Main-module--padded--3nR_1";